import { useTranslation } from "react-i18next";
import { Button, Form, Layout, message, Spin, Tabs } from "antd";
import { useForm } from "antd/es/form/Form";
import { TabsProps } from "antd/lib";
import { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import FilterExamTable from "../../../components/course-library/personal-exam-repository/bank-question/filter-table-exam";
import PageHeader from "../../../components/page-header/PageHeader";
import {
  editUnitBank,
  getAllUniversityInUnitBank,
  getPageUnitBank,
  updateUnitBank,
} from "../../../service/library";
import {
  createNewUnitBank,
  getAllTeacherAndFacility,
} from "../../../service/library/question-list";
import MyQuestionBank from "./components/my-question-bank/MyQuestionBank";
import FormCreateQuestionBank from "./components/form-create-question-bank/FormCreateQuestionBank";
import { globalStore } from "../../../stores/stores";
import useKeyword from "../../../hooks/useKeyword";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import { AppstoreOutlined, TableOutlined } from "@ant-design/icons";
import FilterBankQuestionList from "../../../components/course-library/personal-exam-repository/bank-question/filter-group";
import { QuestionBankData } from "../../../types/question-bank";

type BankQuestionProps = {
  mode?: string | null;
  modalMode?: string;
  selectedMode?: boolean;
  unitId?: string | null;
  blockId?: string | null;
  courseBlockGroupIdClick?: number;
  selectedBank?: QuestionBankData[];
  setSelectedBank?: (values: QuestionBankData[]) => void;
};

const BankQuestion = ({
  mode,
  unitId,
  blockId,
  modalMode,
  selectedMode,
  selectedBank,
  courseBlockGroupIdClick,
  setSelectedBank,
}: BankQuestionProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [tab, setTab] = useState<string>("1");
  const { personalInfo } = globalStore();
  const redirectUrl = useKeyword("redirectUrl");
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingForm, setIsLoadingForm] = useState(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);

  const [page, setPage] = useState<number>(1);
  const [size, setPageSize] = useState<number>(10);
  const [searchValue, setSearchValue] = useState<string>("");
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
  const [editBankId, setEditBankId] = useState<number>(0);
  const [dataAuthor, setDataAuthor] = useState<any>({});
  const [userLogin, setUserLogin] = useState<any>({});

  const [allowedUserOptions, setAllowedUserOptions] = useState([]);
  const [dataQuestionBank, setDataQuestionBank] = useState([]);
  const [dataUniversity, setDataUniversity] = useState([]);
  const [detailDataQuestionBank, setDetailDataQuestionBank] = useState({});
  const [filterData, setFilterData] = useState<any>({
    owner: null,
    permission: null,
    updatedDateTo: null,
    updatedDateFrom: null,
  });

  const [viewMode, setViewMode] = useState<"table" | "card">(
    localStorage.getItem("question-bank-view") === "card" ? "card" : "table"
  );

  // Filter
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const clearFilter = () => {
    form.resetFields();
    setFilterData({
      owner: null,
      permission: null,
      updatedDateTo: null,
      updatedDateFrom: null,
    });
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      if (page === 1) {
        fetchDataQuestionBank();
      } else {
        setPage(1);
      }
    }
  };

  const handleSubmitSearch = () => {
    if (page === 1) {
      fetchDataQuestionBank();
    } else {
      setPage(1);
    }
  };

  const handleFinish = (values: any) => {
    setPage(1);
    setFilterData({
      ...filterData,
      owner: values?.owner,
      permission: values?.permission,
      updatedDateFrom: values?.updatedDate
        ? values?.updatedDate[0].endOf("day").toISOString()
        : null,
      updatedDateTo: values?.updatedDate
        ? values?.updatedDate[1].endOf("day").toISOString()
        : null,
    });
  };

  // onClose
  const onClose = () => {
    setIsOpen(false);
    setIsOpenEdit(false);
    form.resetFields();
  };

  // get detail question bank
  const getDetailData = async (bankId: number) => {
    setEditBankId(bankId);
    try {
      const res = await editUnitBank(bankId);
      if (res.status === 200) {
        const getDetail = res.data?.data;
        const author = getDetail?.authors?.find(
          (item: any) => item.permission === "1"
        );
        setDataAuthor(author);
        setDetailDataQuestionBank(getDetail);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Tab items
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: t("Của tôi", "Của tôi"),
      disabled: isLoading,
    },
    {
      key: "2",
      label: t("Được chia sẻ", "Được chia sẻ"),
      disabled: isLoading,
    },
  ];

  // fetch data lecturer
  const fetchLecturerData = async () => {
    setIsLoadingForm(true);
    try {
      const res = await getAllTeacherAndFacility({});
      if (res.status === 200) {
        const data = res.data.data?.content?.map((item: any) => {
          if (item.email === personalInfo.email) {
            setUserLogin({
              id: item.id,
              email: item.email,
              avatar: item.imagePath,
              universityMember: item.universityName,
              isLoginUser: true,
            });
          }
          return {
            id: item.id,
            name: item.email,
            avatar: item.imagePath,
            universityMember: item.universityName,
            isLoginUser: item.email === personalInfo.email,
          };
        });

        setAllowedUserOptions(data);
        setIsLoadingForm(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingForm(false);
    }
  };

  // handle create - update question bank
  const onFinishCreate = async (values: any) => {
    setIsLoadingForm(true);

    if (!isOpenEdit) {
      const dataReq = {
        title: values.name,
        description: values.description ? values.description : null,
        industries: values.faculty ? values.faculty : [],
        topics: [],
        tags: [],
      };

      try {
        const res = await createNewUnitBank(dataReq);
        if (res.status === 200) {
          message.success(t("Thêm mới thành công!", "Thêm mới thành công!"));
          fetchDataQuestionBank();
          setIsLoadingForm(false);
          onClose();
          if (redirectUrl)
            navigate(decodeURIComponent(`${redirectUrl}&isReturn=true`));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoadingForm(false);
      }
    } else {
      const dataReq = {
        id: editBankId,
        title: values.name,
        description: values.description ? values.description : null,
        industries: values.faculty ? values.faculty : [],
        topics: [],
        tags: [],
      };

      try {
        const res = await updateUnitBank(dataReq);
        if (res.status === 200) {
          message.success(t("Chỉnh sửa thành công!", "Chỉnh sửa thành công!"));
          fetchDataQuestionBank();
          setIsLoadingForm(false);
          onClose();
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoadingForm(false);
      }
    }
  };

  // fetch data question bank
  const fetchDataQuestionBank = async () => {
    setIsLoading(true);
    const dataReq = {
      page: page,
      size: size,
      keyword: searchValue,
      isShared: tab === "2",
      canEdit: tab === "2" ? selectedMode : null,
      productionUnitId: filterData.owner ? filterData.owner : null,
      accessPermission: filterData.permission
        ? Number(filterData.permission)
        : null,
      updatedDateFrom: filterData.updatedDateFrom
        ? filterData.updatedDateFrom
        : null,
      updatedDateTo: filterData.updatedDateTo ? filterData.updatedDateTo : null,
      sort: ["created_date, desc"],
    };
    try {
      const res = await getPageUnitBank(dataReq);
      if (res.status === 200) {
        setDataQuestionBank(res.data.data.content);
        setTotalRecords(res.data.data.totalElements);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // get all university
  const getAllUniversity = async () => {
    setIsLoading(true);
    try {
      const res = await getAllUniversityInUnitBank();
      if (res.status === 200) {
        const listUniversity = res.data.data?.map((item: any) => {
          return {
            label: item.universityName,
            value: item.enterpriseUuid,
          };
        });
        setDataUniversity(listUniversity);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect
  useEffect(() => {
    fetchDataQuestionBank();
  }, [tab, page, size, filterData]);

  useEffect(() => {
    if (isOpen) {
      fetchLecturerData();
    }
  }, [isOpen]);

  useEffect(() => {
    if (redirectUrl) {
      setIsOpen(true);
    }
  }, [redirectUrl]);

  useEffect(() => {
    if (tab === "2") {
      getAllUniversity();
    }
  }, [tab]);

  useEffect(() => {
    localStorage.setItem("question-bank-view", viewMode);
  }, [viewMode]);

  return (
    <Layout className="page-header-group unit-list-page">
      <Form.Provider>
        <div
          className={`page-header-group--layout ${
            showFilter ? "open-filter" : ""
          }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              {selectedMode ? (
                <>{t("Ngân hàng câu hỏi", "Ngân hàng câu hỏi")}</>
              ) : (
                <PageHeader title={t("Ngân hàng câu hỏi", "Ngân hàng câu hỏi")} />
              )}
            </div>

            <FilterExamTable
              mode={mode}
              modalMode={modalMode}
              selectedMode={selectedMode}
              unitId={unitId}
              blockId={blockId}
              searchValue={searchValue}
              courseBlockGroupIdClick={courseBlockGroupIdClick}
              setIsOpen={setIsOpen}
              handleSearch={handleSearch}
              handleChangeInput={handleChange}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
            />
          </div>
          <FilterBankQuestionList
            tab={tab}
            form={form}
            showFilter={showFilter}
            dataUniversity={dataUniversity}
            onFinish={handleFinish}
            clearFilter={clearFilter}
          />
          <Tabs
            className="question-bank-tabs"
            items={items}
            onChange={(tab) => {
              setTab(tab);
              setPage(1);
            }}
            tabBarExtraContent={
              <div className="flex gap-8">
                <Button
                  onClick={() => setViewMode("table")}
                  className={`${viewMode === "table" ? "button-choose" : ""}`}
                >
                  <TableOutlined
                    style={{ color: viewMode === "table" ? "#9F224E" : "#000" }}
                  />
                </Button>

                <Button
                  onClick={() => setViewMode("card")}
                  className={`${viewMode === "card" ? "button-choose" : ""}`}
                >
                  <AppstoreOutlined
                    style={{ color: viewMode === "card" ? "#9F224E" : "#000" }}
                  />
                </Button>
              </div>
            }
          />
        </div>
        <MyQuestionBank
          tab={tab}
          page={page}
          size={size}
          viewMode={viewMode}
          isLoading={isLoading}
          searchValue={searchValue}
          selectedMode={selectedMode}
          selectedBank={selectedBank}
          totalRecords={totalRecords}
          dataQuestionBank={dataQuestionBank}
          setPageNumber={setPage}
          setPageSize={setPageSize}
          setIsOpen={setIsOpen}
          setIsOpenEdit={setIsOpenEdit}
          getDetailData={getDetailData}
          setSearchValue={setSearchValue}
          setSelectedBank={setSelectedBank}
          fetchDataQuestionBank={fetchDataQuestionBank}
        />
      </Form.Provider>

      <FormCreateQuestionBank
        form={form}
        open={isOpen}
        isOpenEdit={isOpenEdit}
        isLoadingForm={isLoadingForm}
        detailDataQuestionBank={detailDataQuestionBank}
        onClose={onClose}
        onFinishCreate={onFinishCreate}
        setIsLoadingForm={setIsLoadingForm}
      />
    </Layout>
  );
};

export default BankQuestion;
